import { scrollIntoView } from '@helpers/animate';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './SkipLink.styles';
const SkipLink = ({ type = 'inline' }) => {
    const ref = React.useRef(null);
    return (React.createElement(S.Container, null,
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Button, { ref: ref, onClick: () => {
                    if (type === 'header') {
                        skipToMain();
                    }
                    else {
                        skipSection();
                    }
                } }, type === 'header' ? React.createElement(React.Fragment, null, "Skip to Main Content") : React.createElement(React.Fragment, null, "Skip to Next Section")))));
    function skipToMain() {
        const targetEl = document.getElementById('main');
        if (!targetEl) {
            return;
        }
        scrollIntoView(targetEl);
        focusNext(targetEl);
    }
    function skipSection() {
        let wrapperEl = ref.current?.closest('div[class^=react_Components_]');
        // Should only ever occur in storybook
        if (!wrapperEl) {
            wrapperEl = ref.current?.closest('section');
        }
        let targetEl = wrapperEl?.nextElementSibling;
        // Last element in main wrapper, next element is footer
        if (!targetEl) {
            targetEl = wrapperEl?.parentElement?.nextElementSibling;
        }
        if (!targetEl) {
            return;
        }
        scrollIntoView(targetEl);
        focusNext(targetEl);
    }
    function focusNext(el) {
        const focusable = el.querySelectorAll('button');
        focusable[0]?.focus();
    }
};
export default SkipLink;
